<template>
  <NuxtLayout>
    <TextHeader narrow-text />
    <section v-if="page.featured_offer_groups?.length" class="offerList__Featured container">
      <div class="offerList__FeaturedTop">
        <img src="/resources/images/featured-offers.svg" width="24" height="24" />
        <h2 v-text="$t('recommendedOffers')" />
      </div>
      <div class="offerList__FeaturedList">
        <FlickitySlider class="offerList__FeaturedSlider">
          <div v-for="item in page.featured_offer_groups" :key="item.id" class="offerList__FeaturedSliderItem">
            <Flare v-if="item.image" class="offerList__ImageDesktop" :srcset="item.image" size="both" width="1300" height="700" crop="fill" :alt="item.image" />
            <Flare v-if="item.image || item.image_mobile" class="offerList__ImageMobile" :srcset="item.image_mobile ? item.image_mobile : item.image" size="both" width="768" height="1160" crop="fill" :alt="item.image_mobile ? item.image_mobile : item.image" />
  
            <div class="offerList__SliderItemTexts">
              <div class="offerList__SliderItemTextsContent">
                <h2 v-text="item.title" />
                <h3 v-text="item.subtitle" />
                <Button v-if="item.sef" :to="item.sef" type="nuxt-link" negative medium>{{ $t('checkOffers') }}</Button>
              </div>
  
              <ClientOnly v-if="item.expiration">
                <OfferTimer :item="item"/>
              </ClientOnly>
              <div v-else-if="item.image_document_discount?.meta?.format === 'svg' && item.image_document_discount.meta.url">
                <div class="offerList__FeaturedSliderDiscount">
                  <img :src="item.image_document_discount.meta.url" :alt="item.image_document_discount.title || ''" width="140" height="140" />
                </div>
              </div>
            </div>
          </div>
        </FlickitySlider>
      </div>
    </section>

    <transition name="fade">
      <OfferExpiredRibbon v-if="offerExpired" />
    </transition>
  
    <Pagination
      ref="paginationElement"
      endpoint="/offer/"
      :selectedFilters="selectedFilters"
      @search="data = $event"
      class="offers__ListWrapper"
      counterText="offersAvailable"
    >
			<template #filters-top>
        <h2 v-text="$t('allOffers')"></h2>
				<Filters :data="filtersList" v-model="selectedFilters" @close="filterData" @item-remove="filterData" />
			</template>

      <OfferItem v-for="offer in data.results" :data="offer" :key="offer.id" />

      <template #no-results>
				<p v-text="$t('noResultsOffers')" />
			</template>
		</Pagination>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  const props = defineProps({
    page: {
      type: Object
    }
  })

  const { t } = useI18n();
  const { initialData } = useSetup();
  const { query } = useRoute();
  const selectedFilters = ref({});
  const offerExpired = ref(false);
  const data = ref([]);
  const paginationElement = ref(null);

  const queryParams = computed(() => {
    const _query = JSON.parse(JSON.stringify(query));
    for (const key of ['dates', 'date_from', 'date_to']) delete _query[key]
    return _query;
  });

  const filtersList = [
    {
      title: t('filtersTexts.region'),
      identifier: FilterIdentifiersObject.REGION.backendId,
      items: initialData.value[FilterIdentifiersObject.REGION.frontendId] ? initialData.value[FilterIdentifiersObject.REGION.frontendId] : []
    },
    {
      title: t('filtersTexts.propertyType'),
      identifier: FilterIdentifiersObject.PROPERTY_TYPE.backendId,
      items: getPropertyTypeFilters(t)
    },
    {
      title: t('filtersTexts.offerType'),
      identifier: FilterIdentifiersObject.OFFER_TYPE.backendId,
      items: initialData.value[FilterIdentifiersObject.OFFER_TYPE.frontendId] ? initialData.value[FilterIdentifiersObject.OFFER_TYPE.frontendId] : []
    },
    {
      title: t('filtersTexts.holidayType'),
      identifier: FilterIdentifiersObject.HOLIDAY_TYPE.backendId,
      items: initialData.value.amenities?.[FilterIdentifiersObject.HOLIDAY_TYPE.frontendId] ? initialData.value.amenities[FilterIdentifiersObject.HOLIDAY_TYPE.frontendId] : []
    },
  ];

  async function filterData() {
		paginationElement.value.filterData();
  }

  onMounted(() => {
    if (sessionStorage.getItem('offerExpired')) {
      offerExpired.value = true;
      setTimeout(() => {
        sessionStorage.removeItem('offerExpired');
        offerExpired.value = false;
      }, 10000);
    }
  });

  onBeforeUnmount(() => {
    if (import.meta.client) sessionStorage.removeItem('offerExpired');
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_offers.scss');
  @import url('@/assets/styles/pages/_offerList.scss');
</style>